"use client";

import { ContactPage } from "@/types/wordpress";
import Module1 from "./Module1";
import ModuleFaqs from "./ModuleFaqs";
import ModuleMaps from "./ModuleMaps";
import { useLanguageUrl } from "@/context/languageURLContext";
import { useEffect } from "react";

interface ContactComponentProps {
  data: ContactPage;
}

export default function ContactComponent({ data }: ContactComponentProps) {
  const { setUrl } = useLanguageUrl(); // Access context values

  useEffect(() => {
    setUrl(data.pages.nodes[0].translations[0].uri);
  }, [data.pages.nodes, setUrl]);

  return (
    <>
      <Module1 content={data.pages.nodes[0].contact.contactContentText} />
      <ModuleMaps
        mapLink={data.pages.nodes[0].contact.mapLink}
        mapIframe={data.pages.nodes[0].contact.mapIframe}
      />
      <ModuleFaqs
        title={data.pages.nodes[0].contact.faqsTitle}
        faqs={data.pages.nodes[0].contact.faqsFaqs}
      />
    </>
  );
}
